import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Urls } from 'src/app/Helpers/Urls';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  url = new Urls();
  flmApiUrl: string;
  orgId: number;

  constructor(
    private httpclient: HttpClient
  ) {
      this.flmApiUrl = environment.flmApiUrl;
  }

  getFiles(page, size, fileid, filename, bucketname, start, end) {
    // tslint:disable-next-line: max-line-length
    const url = this.flmApiUrl + '/api/files/' + page + '/' + size + '/' + fileid + '/' + filename
     + '/' + bucketname + '/' + start + '/' + end + '/';
    return this.httpclient.get<any>(url)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  getFile(bucketname, filename) {
    // tslint:disable-next-line: max-line-length
    const url = this.flmApiUrl + '/api/files/' + bucketname + '/' + filename + '/';
    return this.httpclient.get<any>(url)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  downloadFile(url, type) {
    let headers = new HttpHeaders();
    // headers = headers.set('Accept', 'application/pdf');
    headers = headers.set('Accept', type);
    headers = headers.set('Remove', 'r');
    return this.httpclient.get(url, { headers, responseType: 'blob' as 'json' });
  }

  postFile(file) {
    return this.httpclient.post(this.flmApiUrl + '/api/files', file)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  private handleError(error: any) {
    throw error;
    return error;
  }

}
